import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const EXCLUDE_BULK = [
    "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE",
    "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM",
];

const onBuildRestOverrides = (uri) => ({
    LIST: { url: `/${uri}` },
    CREATE: { url: `/${uri}` },
    UPDATE: { url: `/${uri}` },
    REMOVE: { url: `/${uri}` },
    DETAIL: { url: `/${uri}/:id` },
});

const CATEGORIES = buildModuleApi({
    prefix: "WISHLIST_CATEGORIES", uri: "wishlist/categories", withExtra: false, exclude: EXCLUDE_BULK,
    overrides: onBuildRestOverrides("wishlist/categories"),
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const ITEMS = buildModuleApi({
    prefix: "WISHLIST_ITEMS", uri: "wishlist/items", withExtra: false, exclude: EXCLUDE_BULK,
    overrides: onBuildRestOverrides("wishlist/items"),
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

export const WISHLIST_CATEGORY_CONSTANTS = CATEGORIES.CONSTANTS;
export const WISHLIST_ITEM_CONSTANTS = ITEMS.CONSTANTS;
export const WISHLIST_ENDPOINTS = { ...CATEGORIES.ENDPOINTS, ...ITEMS.ENDPOINTS };
